import { PlusIcon } from "lucide-react";
import { Link } from "react-router-dom";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { SearchBar } from "@/components/search-bar";
import { useTableControl } from "@/components/table-control";
import { Button } from "@/components/ui/button";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { useGetAdminRoomSystems } from "@/features/room-systems/api/get-admin-room-systems";
import { RoomSystemsTable } from "@/features/room-systems/components/room-systems-table";

export function AdminRoomSystems() {
  const { pagination, setPagination, search, setSearch } = useTableControl();

  const {
    data,
    isLoading,
    isSuccess,
    isError,
    error,
    isPlaceholderData,
    isFetching,
  } = useGetAdminRoomSystems({
    pageSize: pagination.pageSize,
    pageIndex: pagination.pageIndex,
    search: search ?? undefined,
  });

  if (isLoading)
    return (
      <section>
        <OnboardingHeader
          title="Room Systems"
          description="View and manage physical Room Systems"
          className="mb-6"
        />
        <LoadingScreen />
      </section>
    );

  if (isError || !isSuccess) {
    return <ErrorMessage error={error} />;
  }

  return (
    <section>
      <OnboardingHeader
        title="Room Systems"
        description="View and manage physical Room Systems"
        className="mb-6"
      />
      {isSuccess && (
        <>
          <div className="mb-2 flex flex-col justify-between gap-2 sm:flex-row">
            <SearchBar search={search} setSearch={setSearch} />

            <Button asChild>
              <Link to="/admin/room-systems/new">
                <PlusIcon className="mr-1 size-4 text-inherit" /> Add Room
                System
              </Link>
            </Button>
          </div>
          <RoomSystemsTable
            data={data.items}
            pagination={pagination}
            onPaginationChange={setPagination}
            pageCount={Math.ceil(data.count / pagination.pageSize)}
            isLoading={isFetching && isPlaceholderData}
          />
        </>
      )}
    </section>
  );
}
